/*
 * The "Looks perfect" burst (assets/ew-greeting.js) on other buttons: a tap on any
 * `[data-burst]` throws the same gold and navy specks out of the button's centre. The styles
 * are the greeting's own `.ewg-pw` / `.ewg-p` / `.ewg-burst` rules in assets/app.scss.
 *
 * The specks are made on the first tap, not in the markup, so a button whose label is
 * rewritten (the add-to-cart price, the strip's busy state) gets them back on the next one.
 * Reduced motion: no burst.
 *
 * A button that closes what it sits in (the gift sheet's Done) calls `EWBurst.play(button)`
 * itself and waits `EWBurst.holdMs` before closing when it returns true, the way "Looks
 * perfect" does; mark it `data-burst='manual'` so the tap is not played twice.
 */
(function () {
  if (window.EWBurst) return;

  // Same specks as the greeting's OKSPECKS: class, size px, dx, dy, spin deg, extra delay s.
  const SPECKS = [
    ['st', 7, -46, -16, 90, 0],
    ['dt', 4, -22, -24, 0, 0.02],
    ['st', 6, 0, -28, -90, 0.01],
    ['dt', 4, 24, -22, 0, 0.03],
    ['st', 7, 46, -14, 120, 0],
    ['dt ewg-nv', 3, -34, 18, 0, 0.02],
    ['st', 5, 30, 20, -120, 0.04],
    ['dt', 3.5, -8, 24, 0, 0.03],
  ];
  const BURST_MS = 700;

  function reduced() {
    return !!(
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  // CSSOM writes, not style attributes, so a strict CSP without 'unsafe-inline' still allows them.
  function specks(btn) {
    let pw = btn.querySelector(':scope > .ewg-pw');
    if (pw) return;
    pw = document.createElement('span');
    pw.className = 'ewg-pw';
    pw.setAttribute('aria-hidden', 'true');
    SPECKS.forEach(function (p) {
      const el = document.createElement('i');
      el.className = 'ewg-p ewg-' + p[0];
      el.style.setProperty('--s', p[1] + 'px');
      el.style.setProperty('--dx', p[2] + 'px');
      el.style.setProperty('--dy', p[3] + 'px');
      el.style.setProperty('--rt', p[4] + 'deg');
      el.style.setProperty('--dl', p[5] + 's');
      pw.appendChild(el);
    });
    btn.appendChild(pw);
  }

  function play(btn) {
    if (!btn || reduced()) return false;
    specks(btn);
    clearTimeout(btn._ewBurst);
    btn.classList.remove('ewg-burst');
    void btn.offsetWidth;
    btn.classList.add('ewg-burst');
    btn._ewBurst = setTimeout(function () {
      btn.classList.remove('ewg-burst');
    }, BURST_MS);
    return true;
  }

  // Capture phase: the handlers behind these buttons can disable them or swap their label
  // before a bubbling listener would run.
  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest ? e.target.closest('[data-burst]') : null;
      if (!btn || btn.disabled || btn.getAttribute('data-burst') === 'manual')
        return;
      if (btn.getAttribute('aria-busy') === 'true') return;
      play(btn);
    },
    true,
  );

  window.EWBurst = { play: play, holdMs: 280 };
})();
